<template>
  <section>
    <Modal
      :title="gatewayData.isLoading ? 'Gateway Inspector' : 'Gateway Inspector (' + gatewayData.data.payload_transmission.upstream_dev_id + ')'"
      :background-primary="true"
      @close="$parent.close()"
    >
      <div class="is-gatewayinspector-modal">
        <div class="modal-card is-page-modal">
          <b-loading
            :is-full-page="false"
            :active.sync="gatewayData.isLoading"
            :can-cancel="false"
          />
          <b-table
            ref="gateway-table"
            class="is-gateway-table"
            :data="gatewayData.isLoading ? [] : gatewayData.data.payload_transmission.upstream_metadata.gateways"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="false"
            :loading="false"
            :focusable="false"
            :mobile-cards="false"
            sort-icon="arrow-up"
            sort-icon-size="is-small"
            default-sort-direction="desc"
            default-sort="snr"
            :per-page="4"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column
                field="gtw_id"
                label="Gateway ID"
                sortable
              >
                <a
                  v-clipboard:copy="props.row.gtw_id"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >{{ props.row.gtw_id }}</a>
              </b-table-column>

              <b-table-column
                field="timestamp"
                label="Timestamp"
                sortable
              >
                {{ props.row.timestamp }}
              </b-table-column>

              <b-table-column
                field="channel"
                label="Channel"
                sortable
              >
                {{ props.row.channel }}
              </b-table-column>

              <b-table-column
                field="rssi"
                label="RSSI"
                sortable
              >
                {{ props.row.rssi }}
              </b-table-column>

              <b-table-column
                field="snr"
                label="SNR"
                sortable
              >
                {{ props.row.snr }}
              </b-table-column>

              <b-table-column
                field="rf_chain"
                label="RF Chain"
                sortable
              >
                {{ props.row.rf_chain }}
              </b-table-column>

              <b-table-column
                field="altitude"
                label="Altitude"
                sortable
              >
                {{ props.row.altitude }}
              </b-table-column>

              <b-table-column
                field="time"
                label="Time"
                sortable
                centered
              >
                <span class="tag is-dark">{{ new Date(props.row.time).toLocaleString() }}</span>
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="access-point"
                      pack="mdi"
                      size="is-large"
                    />
                  </p>
                  <p>There are no gateways.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script>
import TelemetryApi from "@/services/Telemetry";
import Modal from "@/components/elements/Modal.vue";
import { mapActions } from "vuex";

export default {
  name: "GatewayInspector",
  components: {
    Modal,
  },
  props: {
    uuid: String,
    data: Object,
  },
  data() {
    return {
      gatewayData: {
        data: {},
        isEmpty: true,
        isLoading: true,
      },
    };
  },
  methods: {
    ...mapActions({
      throwGlobalNotification: "throwGlobalNotification",
    }),
    getGatewayData() {
      this.gatewayData.isLoading = true;
      TelemetryApi.telemetryData(this.uuid)
        .then((response) => {
          if (response != null) {
            this.gatewayData.data = response;
            this.gatewayData.isEmpty = false;
          }
          this.gatewayData.isLoading = false;
        })
        .catch((err) => {
          this.throwGlobalNotification({
            message: "An error has occurred: " + err.name,
            queue: false,
            isError: true,
          });
          this.gatewayData.isLoading = false;
        });
    },
    // eslint-disable-next-line
    onCopy(e) {
      this.throwGlobalNotification({
        message: "Copied to clipboard",
        queue: true,
        isError: false,
      });
    },
    // eslint-disable-next-line
    onError(e) {
      this.throwGlobalNotification({
        message: "Failed to copy to clipboard",
        queue: false,
        isError: true,
      });
    },
  },
  mounted() {
    if (typeof this.data != "undefined") {
      this.gatewayData.data = this.data;
      this.gatewayData.isLoading = false;
    } else {
      this.getGatewayData();
    }
  },
};
</script>

<style lang="scss">
.is-gateway-table {
  margin-left: 1rem;
  margin-right: 1rem;
}

.is-gatewayinspector-modal {
  min-height: 8rem;
  height: auto;
  min-width: 50rem;
  width: auto;
  overflow-y: auto;
}
</style>